module.exports = __webpack_public_path__ + "public/Icons/manage_location.svg?3f1060ae";